import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular from 'angular';

export class FeatureCustomersService {
  static $inject = ['$state', '$uibModal'];

  readonly name = 'customers';
  readonly key = 'enableCustomersOrgCheckout';

  constructor(
    private $state: StateService,
    private $uibModal: UIBModalService,
  ) {}

  /**
   * Prompts using modal in the final location where the feature will eventually live
   * This functionality is currently encapsulated within the feature
   * If this flag is removed we will want to migrate this code into the view where
   * this method is called from
   */
  prompt(customer: TODO) {
    this.$uibModal
      .open<{ params: { customerId: number; accountId?: number } }>({
        templateUrl: 'views/application/views/customers/modals/order/order.tpl.html',
        size: 'md',
        controller: 'CustomersModalsOrderController',
        resolve: {
          customer: () => customer,
        },
      })
      .result.then((response) => {
        this.$state.go('application.orders.create', response.params);
      })
      .catch(function () {
        // noop
      });
  }
}

export const FeatureCustomersServiceModule = angular
  .module('acme.common.service.feature.customers', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.customers.modals.order.controllers',
  ])
  .service('FeatureCustomersService', FeatureCustomersService).name;
